import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    butt:{
        display:'flex',
        justifyContent:'space-between',
    },
    grow: {
        flexGrow: 1,
      },
      divider: {
        margin: '20px 0',
      },
}))